module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep11-0e78ec9860c5719ce7d31437e9eedeec.wav";